<article class="">
    <header class="">
        <div class="">
            <ul class="list-inline d-flex justify-content-between mb-0">
                <li class="list-inline-item">
                    <h1 class="">Coverage</h1>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info mx-1" (click)="printPage()">
                        <i class="ti ti-printer"></i>
                    </button>
                    <button aria-label="Copy link" class="btn btn-icon btn-light-info" (click)="copyFullPageText()">
                        <i class="ti ti-copy"></i>
                    </button>
                </li>
            </ul>
        </div>
    </header>
    <div class=""> 
        <div class="card-body p-2">
            <p class="mt-1"><strong>Coverage</strong> is the percentage of lanes that Xeneta can provide benchmarking for.</p>
            <p>This allows you to compare your volume and spend to the rest of the market for your trade lanes.</p>
            <p>When Xeneta has benchmarking coverage for your trade lane, you can compare your spend to the market low,
                average, and high to determine your overall spending performance and cost-effectiveness.</p>
        </div>
    </div>
</article>